import { Component, ElementRef, EventEmitter, Injector, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { AppConsts } from '@shared/AppConsts';
import { AppComponentBase } from '@shared/common/app-component-base';
import {
	NameValueDto,
	PagedResultDtoOfNameValueDto,
	VendorPricePointServiceProxy,
} from '@shared/service-proxies/service-proxies';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { LazyLoadEvent } from 'primeng/api';
import { Paginator, PaginatorModule } from 'primeng/paginator';
import { Table, TableModule } from 'primeng/table';
import { Observable, Subscribable, Subscription, fromEvent } from 'rxjs';
import { merge as _merge } from 'lodash-es';
import { debounceTime, finalize, take } from 'rxjs/operators';
import { AMPCommonModule } from '@shared/common/common.module';

import * as _ from 'lodash';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';

export interface ICommonLookupModalOptions {
	title?: string;
	isFilterEnabled?: boolean;
	dataSource: (
		skipCount: number,
		maxResultCount: number,
		filter: string,
		tenantId?: number,
		excludeCurrentUser?: boolean
	) => Observable<PagedResultDtoOfNameValueDto>;
	canSelect?: (item: NameValueDto) => boolean | Observable<boolean>;
	loadOnStartup?: boolean;
	pageSize?: number;
	AMPLookupOptions?: IAMPLookupOptions<any>; ///MODIFICACION AMP PARA HABILITAR BOTON DE GUARDADO ACTUALMENTE PARA VENDORPRICEPOINT
	pricePointModal?: boolean;
	revenueModal?: boolean;
}

///MODIFICACION AMP PARA HABILITAR BOTON DE GUARDADO ACTUALMENTE PARA VENDORPRICEPOINT
export interface IAMPLookupOptions<T> {
	withSave: boolean;
	params: T;
	entity?: string;
}

//For more modal options http://valor-software.com/ngx-bootstrap/#/modals#modal-directive

@Component({
	selector: 'commonLookupModal',
	templateUrl: './common-lookup-modal.component.html',
	standalone: true,
	imports: [AMPCommonModule, TableModule, PaginatorModule, ReactiveFormsModule],
})
export class CommonLookupModalComponent extends AppComponentBase implements OnInit, OnDestroy {
	static defaultOptions: ICommonLookupModalOptions = {
		dataSource: undefined,
		canSelect: () => true,
		loadOnStartup: true,
		isFilterEnabled: true,
		pageSize: AppConsts.grid.defaultPageSize,
	};

	textInputControl: FormControl = new FormControl();

	@Output() itemSelected: EventEmitter<NameValueDto> = new EventEmitter<NameValueDto>();

	@ViewChild('modal', { static: true }) modal: ModalDirective;
	@ViewChild('dataTable', { static: true }) dataTable: Table;
	@ViewChild('paginator', { static: true }) paginator: Paginator;

	textInputSub: Subscription;

	options: ICommonLookupModalOptions = _merge({});

	isShown = false;
	isInitialized = false;
	excludeCurrentUser = true;
	tenantId?: number;
	showAddBtn = false;

	constructor(
		injector: Injector,
		private _vendorPricePointsServiceProxy: VendorPricePointServiceProxy
	) {
		super(injector);
	}

	configure(options: ICommonLookupModalOptions): void {
		this.options = _merge(
			{},
			CommonLookupModalComponent.defaultOptions,
			{ title: this.l('SelectAnItem') },
			options
		);
	}

	show(): void {
		if (!this.options) {
			throw Error(
				'Should call CommonLookupModalComponent.configure once before CommonLookupModalComponent.show!'
			);
		}

		this.modal.show();
	}

	refreshTable(): void {
		this.paginator.changePage(this.paginator.getPage());
	}

	close(): void {
		this.modal.hide();
	}

	shown(): void {
		this.isShown = true;
		this.getRecordsIfNeeds(null);
	}

	ngOnInit() {
		this.textInputSub = this.textInputControl.valueChanges
			.pipe(debounceTime(800))
			.subscribe((_) => this.getRecords());
	}

	getRecordsIfNeeds(event?: LazyLoadEvent): void {
		if (!this.isShown) {
			return;
		}

		if (!this.options.loadOnStartup && !this.isInitialized) {
			return;
		}

		this.getRecords(event);
		this.isInitialized = true;
	}

	getRecords(event?: LazyLoadEvent): void {
		const maxResultCount = this.primengTableHelper.getMaxResultCount(this.paginator, event);
		const skipCount = this.primengTableHelper.getSkipCount(this.paginator, event);
		if (this.primengTableHelper.shouldResetPaging(event)) {
			this.paginator.changePage(0);
			if (this.primengTableHelper.records && this.primengTableHelper.records.length > 0) {
				return;
			}
		}

		this.primengTableHelper.showLoadingIndicator();
		this.options
			.dataSource(skipCount, maxResultCount, this.textInputControl.value, this.tenantId, this.excludeCurrentUser)
			.pipe(finalize(() => this.primengTableHelper.hideLoadingIndicator()))
			.subscribe((result) => {
				this.primengTableHelper.totalRecordsCount = result.totalCount;
				this.primengTableHelper.records = result.items;
				this.primengTableHelper.hideLoadingIndicator();
				if (this.options.AMPLookupOptions) {
					this.showSaveBtn(result.items);
				}
			});
	}

	showSaveBtn(items: Array<any>): void {
		if (this.textInputControl.value == '' || items.map((i) => i.name).includes(this.textInputControl.value)) {
			this.showAddBtn = false;
			return;
		}
		this.showAddBtn = true;
	}

	createEntity() {
		if (this.options.AMPLookupOptions.entity == 'vendorPricePoints') {
			this.createVendorPricePoint();
		}
	}

	createVendorPricePoint() {
		let input = this.options.AMPLookupOptions.params;
		input.name = this.textInputControl.value;
		let existPricePoint = _.findIndex(
			this.primengTableHelper.records,
			(pricepoint) => pricepoint.name == input.name
		);
		if (existPricePoint != -1) {
			this.message.error(this.l('PricePointAlreadyExist'));
		} else {
			this._vendorPricePointsServiceProxy
				.createVendorPricePoint(input)
				.pipe(take(1))
				.subscribe((data) => {
					this.message.success(this.l(`PricePointCreatedSuccessfully`));
					this.showAddBtn = false;
					let nameValue = new NameValueDto();
					nameValue.name = data.name;
					nameValue.value = data.id.toString();
					this.itemSelected.emit(nameValue);
					this.close();

					this.refreshTable();
				});
		}
	}

	selectItem(item: NameValueDto) {
		const boolOrPromise = this.options.canSelect(item);
		if (!boolOrPromise) {
			return;
		}

		if (boolOrPromise === true) {
			this.itemSelected.emit(item);
			this.close();
			return;
		}

		//assume as observable
		(boolOrPromise as Observable<boolean>).subscribe((result) => {
			if (result) {
				this.itemSelected.emit(item);
				this.close();
			}
		});
	}

	ngOnDestroy(): void {
		this.textInputSub.unsubscribe();
	}
}
